import { render, staticRenderFns } from "./ExpencesCategoriesContainer.vue?vue&type=template&id=1c1b2a9a&scoped=true"
import script from "./ExpencesCategoriesContainer.vue?vue&type=script&lang=js"
export * from "./ExpencesCategoriesContainer.vue?vue&type=script&lang=js"
import style0 from "./ExpencesCategoriesContainer.vue?vue&type=style&index=0&id=1c1b2a9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1b2a9a",
  null
  
)

export default component.exports